import { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { Avatar, Box, Button, Card, CardContent, CardHeader, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Stack, Tab, Tabs, TextField, Typography } from "@mui/material";

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import moment from "moment";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";
import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout";
import { InfoField } from "../../../components/InfoField";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { defaultExhortoLibrado, ExhortoLibradoProps, GuardarExhortoLibradoParams } from "../../../interfaces/tribunal/ExhortoLibradoInterface";

import { ActualizarEstatus, DetalleExhortoLibrado, GuardarExhortoLibrado } from "../../../connections/tribunal/ExhortoLibradoConnection";

DocumentEditorContainerComponent.Inject(Toolbar);

interface ItemModelModif extends ItemModel {
    value?: string;
}

export const AutorizarExhortoLibradoPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const navigate = useNavigate();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [value, setValue] = useState( 0 );

    const [editorReady, setEditorReady] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [loading, setLoading] = useState( true );
    const [loadingGuardar, setLoadingGuardar] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingRegresar, setLoadingRegresar] = useState( false );

    const [autorizar, setAutorizar] = useState( true );
    const [observaciones, setObservaciones] = useState( '' );

    const [exhortoLibrado, setExhortoLibrado] = useState<ExhortoLibradoProps>( defaultExhortoLibrado );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );
    const [openDialogConfirmacionRegresar, setOpenDialogConfirmacionRegresar] = useState( false );

    let Toolbar: (CustomToolbarItemModel | ToolbarItem)[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    // ------------------------------------------------------------------------------------------------------------------------

    const validateFields = () => {

        let valid = true;

        if ( !autorizar && observaciones.trim() === '' ) {

            dispatch( openSnackbar({ message: 'Debes escribir las observaciones', variant: 'warning' }));
            valid = false;

        }

        return valid;
    }

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const params: GuardarExhortoLibradoParams = {
            idExhortoLibrado: Id ?? '',
            idPlantilla: exhortoLibrado.idPlantilla,
            contenido: syncfusionEditor?.current?.documentEditor.serialize() ?? '',
            idDistritoJudicial: exhortoLibrado.idDistritoJudicial,
            idObjetoExhorto: exhortoLibrado.idObjetoExhorto,
            idClaseExhorto: exhortoLibrado.idClaseExhorto,
            dirigidoJuzgadoEstado: exhortoLibrado.dirigidoJuzgadoEstado
        }

        return await GuardarExhortoLibrado( params );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }));
                    setLoadingGuardar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatus({ idExhortoLibrado: Id ?? '', idEstatus: 48, observacion: '' }).then(resp => {

            setTimeout(() => {

                const { success, message, nombreUsuarioAsignado, asignadoMismoUsuario } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate( `/Tribunal/exhorto-librado/visualizar/${ Id ?? '' }` );

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion( `La siguiente actividad se asignó a ${ nombreUsuarioAsignado }` );

                    }

                    setLoadingFinalizar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleRegresar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingRegresar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingRegresar( false );

            }, 700);

            return;
        }

        await ActualizarEstatus({ idExhortoLibrado: Id ?? '', idEstatus: 46, observacion: observaciones }).then(resp => {

            setTimeout(() => {

                const { success, message, nombreUsuarioAsignado, asignadoMismoUsuario } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate( `/Tribunal/exhorto-librado/elaborar/${ Id ?? '' }` );

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion( `La siguiente actividad se asignó a ${ nombreUsuarioAsignado }` );

                    }

                    setLoadingRegresar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingRegresar( false );

                }

            }, 700);

        });

    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleExhortoLibrado( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setExhortoLibrado( resp );

                        contenidoRef.current = resp.contenido;

                        const mkItem = (text: string, id: string, value: string): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];
                        const joinNames = (arr: string[]) => arr.join(', ');
                        const fmtDate = (d: any) => moment( d ).format( 'DD-MM-YYYY' );

                        let items: ItemModelModif[] = [
                            ...mkItem( 'Fecha Actual', '1', '[Fecha_Actual]' ),
                            ...mkItem( 'Numero de exhorto librado', '2', resp.numeroExhorto ),
                        ];

                        if ( resp.idExpediente !== 0 ) {

                            const { expediente: e } = resp;

                            items.push(
                                ...mkItem( 'Número de Expediente', '4', e.numeroExpediente ),
                                ...mkItem( 'Tipo de Juicio', '6', e.tipoJuicio ),
                                ...mkItem( 'Juzgado Origen', '10', e.juzgadoOrigen ),
                                ...mkItem( 'Fecha del Expediente', '11', fmtDate( e.fecha ) ),
                                ...mkItem( 'Actor(es)', '12', joinNames( e.actores ) ),
                                ...mkItem( 'Demandado(s)', '13', joinNames( e.demandados ) ),
                                ...mkItem( 'Juez', '13', e.juez ),
                            );

                            if ( e.numeroFolio ) items.push( ...mkItem( 'Número de Folio', '14', e.numeroFolio ) );
                            if ( e.secretario ) items.push( ...mkItem( 'Secretario(a) de admisibilidad', '16', e.secretario ) );
                            if ( e.secretarioTramite ) items.push( ...mkItem( 'Secretario(a) de Tramite Mayor', '5', e.secretarioTramite ) );
                            if ( e.secretarioTramiteMenor ) items.push( ...mkItem( 'Secretario(a) de Tramite Menor', '7', e.secretarioTramiteMenor ) );
                            if ( e.secretarioEjecucion ) items.push( ...mkItem( 'Secretario(a) de Ejecucion', '15', e.secretarioEjecucion ) );

                        }

                        if ( resp.idExhortoRecibido !== 0 ) {

                            const { exhortoRecibido: ex } = resp;

                            items.push(
                                ...mkItem( 'Número de Exhorto', '4', ex.numeroExhorto ),
                                ...mkItem( 'Tipo de Juicio', '6', ex.tipoJuicio ),
                                ...mkItem( 'Juzgado Origen', '10', ex.juzgadoOrigen ),
                                ...mkItem( 'Fecha del Exhorto', '11', fmtDate( ex.fecha ) ),
                                ...mkItem( 'Actor(es)', '12', joinNames( ex.actores ) ),
                                ...mkItem( 'Demandado(s)', '13', joinNames( ex.demandados ) ),
                                ...mkItem( 'Juez', '13', ex.juez ),
                                ...mkItem( 'Autoridad del Exhorto', '13', ex.autoridadExhortoRecibido ),
                            );

                            if ( ex.numeroFolio ) items.push( ...mkItem( 'Número de Folio', '14', ex.numeroFolio ) );
                            if ( ex.secretario ) items.push( ...mkItem( 'Secretario(a)', '5', ex.secretario ) );
                            if ( ex.numeroExpedienteOrigen ) items.push( ...mkItem( 'Número de Expediente Origen', '7', ex.numeroExpedienteOrigen ) );

                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText( args?.item.value ?? "" ),
                        },);

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion( `La siguiente actividad se asignó a ${resp.nombreUsuarioAsignado}` );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 47 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 47 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        Obtener();

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Exhorto librado' }, { text: 'Autorizar exhorto librado' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ exhortoLibrado.idEstatus === 3 } />
                    :
                        <>

                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Exhorto librado" {...TabProps( 0 )} />

                                    <Tab
                                        label="Información del expediente"
                                        sx={{ display: exhortoLibrado.idExpediente !== 0 ? 'flex' : 'none' }}
                                        {...TabProps( 1 )}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: exhortoLibrado.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps( 25 )}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box sx={{ display: value === 0 ? 'block' : 'none' }}>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion
                                            numeroSeguimiento={ `GEXL-${ exhortoLibrado.idExhortoLibrado }` }
                                            fecha={ exhortoLibrado.fecha ?? new Date() }
                                            juez={ '' }
                                            numeroExhorto={ exhortoLibrado.numeroExhorto }
                                        />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="¿El exhorto librado se dirige a un juzgado perteneciente al Poder Judicial del Estado?"
                                                    value={ exhortoLibrado.dirigidoJuzgadoEstado ? 'Sí' : 'No' }
                                                />

                                            </Grid>

                                            {
                                                exhortoLibrado.dirigidoJuzgadoEstado
                                                &&
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Distrito judicial donde se dirige el exhorto librado"
                                                            value={ exhortoLibrado.distritoJudicial }
                                                        />

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Objeto del exhorto"
                                                    value={ exhortoLibrado.objetoExhorto }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Clase del exhorto"
                                                    value={ exhortoLibrado.claseExhorto }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <DocumentEditorContainerComponent
                                                    key={ 'DocumentEditorContainer' }
                                                    serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                    height={ '650' }
                                                    ref={ syncfusionEditor }
                                                    enableToolbar={ true }
                                                    showPropertiesPane={ false }
                                                    toolbarItems={ Toolbar }
                                                    autoResizeOnVisibilityChange={ false }
                                                    created={ handleEditorCreated }
                                                >
                                                </DocumentEditorContainerComponent>

                                            </Grid>

                                            {
                                                exhortoLibrado.observaciones.length !== 0
                                                &&
                                                    <Grid size={{ xs: 12, md: 12 }}>

                                                        <Card sx={{ p: 2 }}>

                                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                                Observaciones
                                                            </Typography>

                                                            <Stack spacing={ 2 }>

                                                                {
                                                                    exhortoLibrado.observaciones.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                        <Box key={ i } sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>

                                                                            <Avatar
                                                                                sx={{
                                                                                    width: 36,
                                                                                    height: 36,
                                                                                    fontSize: 12,
                                                                                    fontWeight: 500,
                                                                                    bgcolor: (theme) => theme.palette.primary.main,
                                                                                    color: 'white',
                                                                                }}
                                                                            >
                                                                                { usuario.split( " " ).slice( 0, 2 ).map( n => n[0] ).join( "" ) }
                                                                            </Avatar>

                                                                            <Box
                                                                                sx={{
                                                                                    flex: 1,
                                                                                    bgcolor: "action.hover",
                                                                                    border: "0.5px solid",
                                                                                    borderColor: "divider",
                                                                                    borderRadius: "0 15px 15px 15px",
                                                                                    px: 2,
                                                                                    py: 1.25,
                                                                                }}
                                                                            >
                                                                                <Typography variant="subtitle2" fontWeight={ 500 }>
                                                                                    { usuario } { puesto ? `(${ puesto })` : '' }
                                                                                </Typography>

                                                                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                                                                                    { observacion }
                                                                                </Typography>

                                                                                {
                                                                                    fecha
                                                                                    &&
                                                                                        <Typography variant="caption" color="text.disabled" sx={{ mt: 0.75, display: "block" }}>
                                                                                        {  fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                        </Typography>

                                                                                }

                                                                            </Box>

                                                                        </Box>

                                                                    ))
                                                                }

                                                            </Stack>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ xs: 12, md: 12 }}>

                                                <Card sx={{ p: 1 }}>

                                                    <CardHeader
                                                        title={ <Typography variant="h5">¿Desea autorizar el exhorto librado?</Typography> }
                                                        subheader={
                                                            <FormControl>
                                                                <RadioGroup row>

                                                                    <FormControlLabel
                                                                        label="Si"
                                                                        control={
                                                                            <Radio
                                                                                size="small"
                                                                                checked={ autorizar }
                                                                                onChange={ () => { setAutorizar( true ); setObservaciones( '' ); } }
                                                                            />
                                                                        }
                                                                    />

                                                                    <FormControlLabel
                                                                        label="No"
                                                                        control={
                                                                            <Radio
                                                                                size="small"
                                                                                checked={ !autorizar }
                                                                                onChange={ () => setAutorizar( false ) }
                                                                            />
                                                                        }
                                                                    />

                                                                </RadioGroup>
                                                            </FormControl>
                                                        }
                                                    />

                                                    <Collapse in={ !autorizar }>

                                                        <CardContent>

                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                rows={ 4 }
                                                                label="Observaciones"
                                                                variant="outlined"
                                                                value={ observaciones }
                                                                onChange={ (e) => setObservaciones( e.target.value ) }
                                                                slotProps={{
                                                                    input: { autoComplete: "off" },
                                                                    inputLabel: { shrink: true },
                                                                }}
                                                            />

                                                        </CardContent>

                                                    </Collapse>

                                                </Card>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            disabled={ autorizar || observaciones === '' || loadingRegresar }
                                                            onClick={ () => setOpenDialogConfirmacionRegresar( true ) }
                                                        >
                                                            Regresar exhorto librado a elaborar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            variant="outlined"
                                                            loading={ loadingGuardar }
                                                            onClick={ handleGuardar }
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'right' }}>

                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant="contained"
                                                            disabled={ !autorizar }
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>

                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </Box>

                            </TabPanel>

                            <TabPanel value={ value } index={ 1 }>

                                <BoxInformacionExpediente
                                    expediente={ exhortoLibrado.expediente }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionExhortoRecibido
                                    exhortoRecibido={ exhortoLibrado.exhortoRecibido }
                                />

                            </TabPanel>

                            <Dialog
                                fullWidth
                                maxWidth="xs"
                                open={ openDialogConfirmacionFinalizar }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea finalizar y firmar el exhorto librado?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>
                                    <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant="contained" > Aceptar </Button>
                                </DialogActions>

                            </Dialog>

                            <Dialog
                                fullWidth
                                maxWidth="xs"
                                open={ openDialogConfirmacionRegresar }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea regresar a elaborar el exhorto librado?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>
                                    <Button color="secondary" disabled={ loadingRegresar } onClick={ () => setOpenDialogConfirmacionRegresar( false ) }> Cancelar </Button>
                                    <Button loading={ loadingRegresar } onClick={ handleRegresar } variant="contained" > Aceptar </Button>
                                </DialogActions>

                            </Dialog>

                        </>
            }

        </Layout>
    )
}
